import { render, staticRenderFns } from "./matchesListSkeleton.vue?vue&type=template&id=3d1b8da0&scoped=true&"
import script from "./matchesListSkeleton.vue?vue&type=script&lang=js&"
export * from "./matchesListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b8da0",
  null
  
)

export default component.exports